export default __webpack_public_path__ + "static/media/d123e3a5d8849a2338e6e70cf11a9a8a1600819869898.1fbefda2.webp";